// extracted by mini-css-extract-plugin
export default {"pageInfoCard":"PageInfoCard_pageInfoCard__lQpJP"};